module.exports = __webpack_public_path__ + "img/cg.106efbd3.png";